// Page-render functions with no data dependency at all (not even
// ORDERS/PRODUCTS/SETTINGS) — the simplest possible slice of the
// page-rendering layer to extract, verified the same way as everywhere
// else in this refactor: byte-diff the returned HTML string against the
// original before deleting it. See REFACTOR_SECURITY_REPORT.md, Phase 2
// section ("the large page-render functions themselves").
import { ic } from '../utils/icons.js';

export function viewDenied() {
  return `<div class="empty" style="padding:60px 20px">${ic('alert', 28)}<div style="margin-top:10px;font-weight:800">Accès refusé</div><p class="hint">Votre rôle ne permet pas d'accéder à cette page. Contactez un administrateur si vous pensez que c'est une erreur.</p></div>`;
}

export function viewCalculator() {
  return `<div class="calculator-shell"><div class="calculator-shell-head">${ic('coins', 18)}<b>Calculateur Maison Liik</b><span class="hint">Les coûts et prix viennent automatiquement de la section Produits.</span><button class="btn sm ghost" type="button" onclick="document.getElementById('calculatorFrame').contentWindow.location.reload()">Actualiser</button></div><iframe class="calculator-frame" id="calculatorFrame" title="Calculateur de rentabilité Maison Liik" src="maison-liik-calculateur.html"></iframe></div>`;
}
